import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'

// Enregistrement du service worker pour les notifications push
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(() => {});
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
